import type { SelectOption } from "@/types/SelectOption.ts";

export const caseRoles: SelectOption[] = [
    { id: "Attorney", label: "Attorney" },
    { id: "CaseManager", label: "Case Manager" },
    { id: "DisbursementSpecialist", label: "Disbursement Specialist" },
    { id: "IntakeSpecialist", label: "Intake Specialist" },
    { id: "MedicalRecordsClerk", label: "Medical Records Clerk" },
];
